import { StyledTable } from '@/Components/Elements/StyledComponents/Tables'
import React, { useState, useEffect } from 'react'
import {
    Box,
    Paper,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

const ChatSettingsModal = ({
    show,
    onClose,
    onSave,
    selections = [],
    links = [],
    kedo,
    chatData,
}) => {
    const [localSelections, setLocalSelections] = useState([])

    // Sync local copy with prop
    useEffect(() => {
        setLocalSelections(selections)
    }, [selections, show])

    const toggleLink = (link) => {
        setLocalSelections((prev) => {
            const exists = prev.find((l) => l.id === link.id)
            if (exists) {
                return prev.filter((l) => l.id !== link.id)
            } else {
                return [
                    ...prev,
                    { id: link.id, name: link.name, description: '' },
                ]
            }
        })
    }

    const updateDescription = (id, desc) => {
        setLocalSelections((prev) =>
            prev.map((l) => (l.id === id ? { ...l, description: desc } : l))
        )
    }

    const handleSave = () => {
        localStorage.setItem(
            `chat_link_selections_${chatData.dossier.def_dossier_id}`,
            JSON.stringify(localSelections)
        )
        onSave(localSelections)
        onClose()
    }

    const handleClear = () => {
        setLocalSelections([])
        localStorage.removeItem(
            `chat_link_selections_${chatData.dossier.def_dossier_id}`
        )
        onSave([])
    }

    const isSelected = (id) => localSelections.some((l) => l.id === id)
    const generateDialogFooter = () => {
        return (
            <>
                <StyledButton
                    variant="outlined"
                    color="secondary"
                    onClick={handleClear}
                >
                    {kedo.t('Clear All')}
                </StyledButton>
                <StyledButton color="secondary" onClick={onClose}>
                    {kedo.t('Cancel')}
                </StyledButton>
                <StyledButton onClick={handleSave}>
                    {kedo.t('Save')}
                </StyledButton>
            </>
        )
    }

    return (
        <AppDialog
            aria-labelledby="contained-modal-title-vcenter"
            open={show}
            maxWidth={'lg'}
            fullWidth
            title={
                <>
                    ⚙️{' '}
                    {kedo.t(
                        'BitBean - Add links to understand your questions better.'
                    )}
                </>
            }
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose()
                }
            }}
            headerClose={onClose}
            contentProps={{ dividers: true }}
            actions={generateDialogFooter()}
        >
            <Box>
                <Typography
                    variant="body2"
                    component="p"
                    color="text.disabled"
                    sx={{ mb: 3 }}
                >
                    {kedo.t(
                        'Select one or more dossier links and optionally add descriptions.'
                    )}
                </Typography>

                <Box
                    sx={{ maxHeight: '55vh', overflowY: 'auto' }}
                    className={'table-responsive '}
                >
                    <TableContainer component={Paper}>
                        <StyledTable size="small" hover striped>
                            <TableHead className="thead-light">
                                <TableRow
                                    sx={{
                                        '& .MuiTableCell-head': {
                                            textAlign: 'left',
                                            fontWeight: 'bold',
                                        },
                                    }}
                                >
                                    <TableCell
                                        style={{ width: '40px' }}
                                    ></TableCell>
                                    <TableCell>{kedo.t('Name')}</TableCell>
                                    <TableCell>
                                        {kedo.t('Description')}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{}}>
                                {links.map((link) => {
                                    const selected = isSelected(link.id)
                                    const desc =
                                        localSelections.find(
                                            (l) => l.id === link.id
                                        )?.description || ''
                                    return (
                                        <TableRow key={link.id}>
                                            <TableCell>
                                                <input
                                                    type="checkbox"
                                                    checked={selected}
                                                    onChange={() =>
                                                        toggleLink(link)
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell>{link.name}</TableCell>
                                            <TableCell>
                                                {selected ? (
                                                    <input
                                                        type="text"
                                                        value={desc}
                                                        placeholder={kedo.t(
                                                            'Add description...'
                                                        )}
                                                        onChange={(e) =>
                                                            updateDescription(
                                                                link.id,
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    <Box
                                                        component="small"
                                                        sx={{
                                                            color: 'text.disabled',
                                                        }}
                                                    >
                                                        —
                                                    </Box>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </StyledTable>
                    </TableContainer>
                </Box>
            </Box>
        </AppDialog>
    )
}

export default ChatSettingsModal
